// extracted by mini-css-extract-plugin
export default {"wrapper":"SW8J4iW_be_k0qB0CQyL","buttonContainer":"yoBfxyskuSD7sueIYOWl","or":"gPuHaqEvuZ01mooIj2G5"};